/** Horizontal kiosk card (image + text). Too wide for the default 3-up cross-sell grid. */
export const C6_PRODUCT_CARD_CHOICE = 6;

const PRODUCTS_SCROLL_CLASS = 'overflow-y-scroll p-1 scrollbar-hide';

const DEFAULT_MULTI_PRODUCT_GRID_CLASS = `${PRODUCTS_SCROLL_CLASS} grid justify-center gap-5 lg:[--grid-column-width: 300px] kiosk:[--grid-column-width: 365px]`;

const DEFAULT_FEW_PRODUCTS_CLASS = `${PRODUCTS_SCROLL_CLASS} flex items-stretch justify-around gap-4 kiosk:gap-16`;

const DEFAULT_GRID_TEMPLATE_COLUMNS = 'repeat(auto-fit, var(--grid-column-width))';

/** Two equal columns; a third card wraps onto the next row. */
const C6_TWO_COLUMNS = 'repeat(2, minmax(0, 1fr))';

/** One track, capped so a lone card stays a card and can be centered. */
const C6_SINGLE_COLUMN = 'minmax(0, 365px)';

export interface CrossSellingProductsLayout {
  listClass: string;
  gridTemplateColumns: string;
  stretchCard: boolean;
  fillCardWidth: boolean;
  centerSingleCard: boolean;
  /** Desktop modal grows so two horizontal C6 cards keep a readable text column. */
  wideModal: boolean;
}

export function resolveCrossSellingProductsLayout(input: {
  productCount: number;
  productCardChoice: number | string | null | undefined;
  showsKioskProductCard: boolean;
}): CrossSellingProductsLayout {
  const isC6Layout =
    Number(input.productCardChoice) === C6_PRODUCT_CARD_CHOICE && input.showsKioskProductCard;
  const hasSingleProduct = input.productCount === 1;
  const displayGrid = input.productCount >= 3;

  if (isC6Layout) {
    if (input.productCount <= 1) {
      return {
        listClass: `${PRODUCTS_SCROLL_CLASS} grid justify-center gap-5`,
        gridTemplateColumns: C6_SINGLE_COLUMN,
        stretchCard: false,
        fillCardWidth: true,
        centerSingleCard: true,
        wideModal: false,
      };
    }

    return {
      listClass: `${PRODUCTS_SCROLL_CLASS} grid gap-5`,
      gridTemplateColumns: C6_TWO_COLUMNS,
      stretchCard: false,
      fillCardWidth: true,
      centerSingleCard: false,
      wideModal: true,
    };
  }

  if (displayGrid) {
    return {
      listClass: DEFAULT_MULTI_PRODUCT_GRID_CLASS,
      gridTemplateColumns: DEFAULT_GRID_TEMPLATE_COLUMNS,
      stretchCard: false,
      fillCardWidth: false,
      centerSingleCard: false,
      wideModal: false,
    };
  }

  return {
    listClass: DEFAULT_FEW_PRODUCTS_CLASS,
    gridTemplateColumns: DEFAULT_GRID_TEMPLATE_COLUMNS,
    stretchCard: !hasSingleProduct,
    fillCardWidth: hasSingleProduct,
    centerSingleCard: hasSingleProduct,
    wideModal: false,
  };
}
